<template>
  <div>
    <!-- List payment late -->
    <div class="box box-success">
      <div>
        <div class="box-header" style="text-align:center;margin:auto;">
          <h3 class="box-title">
            {{ $t("dashboard.statistical_export_invoice") }}
          </h3>
          <row style="text-align: center;">
            <div style="display: inline-block;">
              <div style="width:110px; margin-top:5px">
                <div class="input-group date">
                  <date-picker
                    ref="periodPicker"
                    v-model="datePickerValue"
                    @dp-change="onHandleChangeMonth(datePickerValue)"
                    :config="optionsPicker"
                    :placeholder="$t('invoice.issuePeriod')"
                  ></date-picker>
                  <div class="input-group-addon" type="button" @click="$refs.periodPicker.dp.show()">
                    <i class="fa fa-caret-down"></i>
                  </div>
                </div>
              </div>
            </div>
          </row>
        </div>
        <div class="box-body">
          <div class="col-md-12">
            <div class="circle-parent">
              <div class="fraction-child">
                <sup class="sub-style">{{ invoice_exported }}</sup
                ><span class="sub-style">/</span
                ><sub style="color:#4a4a4a" class="sub-style">{{
                  total_invoice
                }}</sub>
              </div>
            </div>
            <div
              style="text-align:center;margin-top: 15px;font-size: 16px;color:#656565"
            >
              <span>{{
                $t("dashboard.invoice_exported_on_total_invoice")
              }}</span>
            </div>
          </div>
          <div class="col-md-12" style="margin-top: 50px;">
            <div class="circle-parent-small">
              <div class="fraction-child-small">
                <span class="sub-style-small">{{
                  invoice_not_export_yet
                }}</span>
                <div>
                  <span>{{ $t("dashboard.invoice") }}</span>
                </div>
              </div>
            </div>
            <div style="margin-top: 15px;color: #656565">
              <span>{{ $t("dashboard.invoice_not_yet_issued") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import datePicker from "vue-bootstrap-datetimepicker";
import utils from '@/lib/utils'
// import moment from 'moment'

export default {
  name: "StatisticalInvoice",
  data() {
    return {
      datePickerValue: moment().format("YYYY/MM"),
      optionsPicker: {
        minDate: new Date(2019, 0),
        maxDate: moment(),
        format: "YYYY/MM",
        locale: this.$i18n.locale == "en" ? "en" : "vi"
      },
      invoice_exported: 0,
      total_invoice: 0,
      invoice_not_export_yet: 0
    };
  },
  watch: {
    GET_LANG: function() {
      this.optionsPicker.locale = this.$i18n.locale == "en" ? "en" : "vi";
    },
    GET_STATISTICAL_EXPORT_INVOICE_DATA: function() {
      let data = this.GET_STATISTICAL_EXPORT_INVOICE_DATA.data;
      if (data) {
        this.total_invoice = data.total_invoice_in_period;
        this.invoice_exported = data.total_invoice_exported_in_period;
        this.invoice_not_export_yet =
          data.total_invoice_in_period - data.total_invoice_exported_in_period;
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_LANG",
      "GET_STATISTICAL_EXPORT_INVOICE_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "GET_STATISTICAL_EXPORT_INVOICE"
    ]),
    onHandleChangeMonth: function(value) {
      this.getStatisticalExportInvoice();
    },
    getStatisticalExportInvoice: function() {
      const filter = {
        ...utils.getAccountingPeriodFromDate(this.datePickerValue, "YYYY/MM")
      };
      this.GET_STATISTICAL_EXPORT_INVOICE(filter);
    }
  },
  components: {
    "date-picker": datePicker
  },
  created() {
    this.getStatisticalExportInvoice();
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.circle-parent {
  width: 200px;
  height: 200px;
  border-width: 5px;
  border-style: solid;
  border-radius: 50%;
  position: relative;
  margin: auto;
  border-color: #9b9b9b;
  color: #727272;
}
.fraction-child {
  text-align: center;
  position: absolute;
  width: 100%;
  top: 35%;
}
.sub-style {
  font-size: 50px;
  color: #727272;
}
@media (max-width: 1400px) {
  .circle-parent {
    width: 120px;
    height: 120px;
  }
  .sub-style {
    font-size: 25px;
  }
}
@media (max-width: 990px) {
  .circle-parent {
    width: 200px;
    height: 200px;
  }
  .sub-style {
    font-size: 50px;
  }
}
.circle-parent-small {
  width: 100px;
  height: 100px;
  border-width: 5px;
  border-style: solid;
  border-radius: 50%;
  position: relative;
  border-color: #9b9b9b;
}
.fraction-child-small {
  text-align: center;
  position: absolute;
  width: 100%;
  top: 15%;
  color: #727272;
}
.sub-style-small {
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/StatisticalInvoice.vue